<template>
  <fragment>
    <v-card>
      <div class="gray-gradient-bg">
        <v-img :src="require(`../assets/brand_logos/${brand.imgPath}`)" class="ma-2"
               @click="$router.push(`/services/brands/${brand.id}`)" style="cursor: pointer;"/>
      </div>
      <v-card-title>
        {{ brand.brandName }}
      </v-card-title>
      <div style="min-height: 56px;">
        <v-list dense v-if="brand.productGroups.length > 0">
          <v-list-item>
            <v-list-item-title>
              {{ $t('serviceProducts') }}
            </v-list-item-title>
            <v-list-item-icon>
              <v-btn icon @click="show = !show">
                <v-icon>
                  {{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                </v-icon>
              </v-btn>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
        <v-expand-transition>
          <div v-show="show">
            <v-divider />
            <v-card-text>
              <ul>
                <template v-for="(item, index) in brand.productGroups">
                <li :key="index">
                  {{ $t(item.productGroupTitle) }}
                </li>
                </template>
              </ul>
            </v-card-text>
          </div>
        </v-expand-transition>
      </div>
      <v-card-actions>
        <v-btn text color="primary" @click="$router.push(`/services/brands/${brand.id}`)">
          {{ $t('button.next') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </fragment>
</template>

<script>
export default {
  name: 'brandCard',
  props: {
    brand: Object,
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    //
  },
};
</script>

<style scoped>

</style>
